// extracted by mini-css-extract-plugin
export default {"hr":"oauth-footer_hr__UCYx4","providerButton":"oauth-footer_providerButton__MPBvJ","disabled":"oauth-footer_disabled__YwcKp","providerLogo":"oauth-footer_providerLogo__Q58hC"};